import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadEventsService {
  private readonly uploadSubject = new Subject<UploadProgressEvent>();
  readonly uploadEvents$ = this.uploadSubject.asObservable();

  uploadProgress(fileName: string, progress: number): void {
    this.uploadSubject.next(new UploadProgressEvent('progress', fileName, progress));
  }

  uploadComplete(fileName: string): void {
    this.uploadSubject.next(new UploadProgressEvent('complete', fileName, 100));
  }

  uploadFailed(fileName: string, error: string): void {
    this.uploadSubject.next(new UploadProgressEvent('error', fileName, 0, error));
  }
}

export class UploadProgressEvent {
  constructor(
    readonly type: UploadProgressEventType,
    readonly fileName: string,
    readonly progress: number,
    readonly error?: string
  ) {}
}

export type UploadProgressEventType = 'initialized' | 'error' | 'complete' | 'progress';
